import { useEffect, useState } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";

function ModuleContent({}) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const name = queryParams.get("type");
  const history = useHistory();
  const { t } = useTranslation();
  const [active, setActive] = useState("");
  const language = localStorage.getItem("i18nextLng");
  const ModuleContentData = t("spaceOperations.KernelModule", {
    returnObjects: true,
  });
  const [detailContent, setDetailContent] = useState({});
  const activeMap = {
    0: "first",
    1: "second",
    2: "third",
    3: "fourth",
    4: "fifth",
  };
  useEffect(() => {
    if (name) {
      setDetailContent(ModuleContentData[name]);
      setActive(name);
    }
  }, [name]);
  const clickTo = () => {
    history.push(`/apply`);
  };
  const handleClick = (index) => {
    history.push(`/solution/KernelModulePage?type=${activeMap[index]}`);
  };
  return (
    <div className="kernelModuleContent">
      <div
        className="moduleContent_banner"
        style={{ background: `url(${detailContent.imgUrl})` }}
      ></div>
      <div className="moduleContent_Info">
        <div className="moduleContent_content">
          <div className="moduleContent_con_left">
            <div className="moduleContent_con_l_nav">
              <div
                className="moduleContent_con_l_nav_title"
                style={
                  language === "zh"
                    ? { fontSize: "28px" }
                    : { fontSize: "22px" }
                }
              >
                <span>{ModuleContentData.nav.title}</span>
                {/* <span
                  className="moduleContent_con_l_nav_titleIcon"
                  style={
                    language === "zh"
                      ? { width: "30px", height: "30px" }
                      : { width: "20px", height: "20px" }
                  }
                >
                  <img src={ModuleContentData.nav.titleIcon} alt="" />
                </span> */}
              </div>
              {ModuleContentData.nav.list?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`moduleContent_con_l_nav_Item ${
                      active == activeMap[index]
                        ? "moduleContent_con_l_nav_Item_active"
                        : null
                    }`}
                    onClick={() => handleClick(index)}
                    style={
                      language === "zh"
                        ? { fontSize: "24px" }
                        : { fontSize: "20px" }
                    }
                  >
                    {item.label}
                  </div>
                );
              })}
              <div className="moduleContent_con_l_bottom">
                <div
                  className="moduleContent_con_l_btncon"
                  style={
                    language === "zh"
                      ? { fontSize: "24px" }
                      : { fontSize: "20px" }
                  }
                >
                  {ModuleContentData.nav.footer}
                </div>
                <div
                  className="moduleContent_con_l_btn"
                  style={
                    language === "zh"
                      ? { fontSize: "24px" }
                      : { fontSize: "20px" }
                  }
                  onClick={() => clickTo()}
                >
                  {ModuleContentData.nav.onLine}
                </div>
              </div>
            </div>
          </div>
          <div className="moduleContent_content_right">
            <p className="moduleContent_con_r_introduce">
              {detailContent.introduce}
            </p>
            <div className="moduleContent_con_r_list">
              {detailContent.list_one?.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`
                        moduleContent_con_r_listOne
                        ${
                          detailContent.list_one.length > 3
                            ? "moduleContent_con_r_listOneWidth2"
                            : "moduleContent_con_r_listOneWidth1"
                        }
                    `}
                  >
                    <img src={item.iconUrl} alt="" />
                    <div className="moduleContent_con_r_listOne_Title">
                      {item.title}
                    </div>
                    <p className="moduleContent_con_r_listOne_con">
                      {item.content}
                    </p>
                  </div>
                );
              })}
            </div>
            <div className="moduleContent_con_r_listCom">
              {detailContent.list_two?.map((item, index) => {
                return (
                  <div key={index} className="moduleContent_con_r_listTwo">
                    <span className="moduleContent_con_r_listTwoDot"></span>
                    <span className="moduleContent_con_r_listTwoDotText">
                      {item}
                    </span>
                  </div>
                );
              })}
            </div>
            <div className="moduleContent_con_r_list">
              {detailContent.list_three?.map((item, index) => {
                return (
                  <div key={index} className="moduleContent_con_r_listThree">
                    <div className="moduleContent_con_r_listThree_img">
                      <img src={item.iconUrl} alt="" />
                    </div>
                    <div className="moduleContent_con_r_listThree_Title">
                      {item.title}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="moduleContent_con_r_list">
              {detailContent.list_four?.map((item, index) => {
                return (
                  <div key={index} className="moduleContent_con_r_listFour">
                    {item}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ModuleContent;
